export class AdjustmentTypeErrorResponse {
  name: any;
  description: any;
}
